(function (angular, btoa) {
	'use strict';
	const service = require('../services/pmtUtilService.js');

	angular.module('PinMeTo.services').service('pmtUtilService', function () {
		this.getByPath = service.getByPath;
		this.match = service.match;
		this.groupsOf = service.groupsOf;
		this.csvDownloadStream = service.csvDownloadStream(btoa);
		this.xlsxDownloadStream = service.xlsxDownloadStream(btoa);
		this.getCurrentUnixTimeStamp = service.getCurrentUnixTimeStamp;
	});
})(angular, window.btoa);
